module.exports = __webpack_public_path__ + "static/media/annaberg.c0f00d95.jpg";